interface FavoriteButtonProps {
  active: boolean;
  onClick: () => void;
  label?: string;
  compact?: boolean;
}

export default function FavoriteButton({ active, onClick, label, compact = false }: FavoriteButtonProps) {
  const text = label ?? (active ? "已收藏" : "收藏");

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border px-4 py-2 text-sm font-medium transition-colors ${
        active
          ? "border-primary-300 bg-primary-50 text-primary-700"
          : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
      } ${compact ? "h-10 w-10 px-0" : ""}`}
      aria-pressed={active}
    >
      <span className="flex h-4 w-4 items-center justify-center">
        <i className={active ? "ri-heart-3-fill text-base" : "ri-heart-3-line text-base"} />
      </span>
      {compact ? <span className="sr-only">{text}</span> : text}
    </button>
  );
}